import 'hammerjs';
import 'moment/locale/pt-br';
import { enableProdMode } from '@angular/core';
import { platformBrowser } from '@angular/platform-browser';

import { AppModule } from './app/app.module';
import { initNewRelic } from './config/newrelic.config';
import { environment } from './environments/environment';

if (environment.newRelicEnabled) {
  initNewRelic();
}

if (environment.production) {
  enableProdMode();
}

platformBrowser().bootstrapModule(AppModule)
  .catch(err => console.error(err));
